import { render, staticRenderFns } from "./detailExaminWH.vue?vue&type=template&id=205173bf&scoped=true"
import script from "./detailExaminWH.vue?vue&type=script&lang=js"
export * from "./detailExaminWH.vue?vue&type=script&lang=js"
import style0 from "./detailExaminWH.vue?vue&type=style&index=0&id=205173bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205173bf",
  null
  
)

export default component.exports